import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import { installDisableNumberInputWheel } from "./utils/disableNumberInputWheel";
import "./index.css";

installDisableNumberInputWheel();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
